import React from "react";
import moment from "moment";
import { Table, Tag } from "antd";

const statusColor = (status) => {
  const s = (status || "").toUpperCase();
  if (s === "APPROVED") return "green";
  if (s === "REJECTED" || s === "DISABLED") return "red";
  if (s === "PAUSED") return "orange";
  return "blue";
};

const PromotionTable = (props) => {
  const column = [
    {
      title: "Template Type",
      dataIndex: "module",
      key: "module",
      render: (text) => text || "Marketing",
    },
    {
      title: "Template Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Tag color={statusColor(text)}>{(text || "-").toUpperCase()}</Tag>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdOn",
      render: (text) => (
        <span>{text ? moment(new Date(text)).format("DD/MM/YYYY") : "-"}</span>
      ),
    },
  ];

  return (
    <Table
      style={{ cursor: "default" }}
      dataSource={props.dataSource}
      loading={props.loading || props.spinning}
      pagination={props.pagination}
      rowKey={(record) => record.id}
      columns={column}
    />
  );
};

export default PromotionTable;
